import { Link as DSLink, Heading, Span } from "@icg360/design-system";

import UnauthLayout from "components/shared/unauth-layout";

import styles from "./contact-us.module.scss";

export const ContactUs = () => {
  return (
    <UnauthLayout size="lg">
      <Heading size="lg">Contact Us</Heading>
      <div className={styles.mainContent}>
        <div>
          <Span bold>
            Having questions about your policy or wanting to make changes?
          </Span>
          <div>
            Contact your insurance representative, the agency or broker listed
            on your policy declaration page.
          </div>
        </div>
        <Span bold>
          For any other questions, contact SageSure Customer Service at{" "}
          <DSLink href="tel: (800) 481-0661">(800) 481-0661</DSLink>
        </Span>
        <div>
          <Span bold>Business hours</Span>
          <div>Monday-Friday: 8am - 9pm ET</div>
          <div>Saturday: 10am - 3pm ET</div>
        </div>
      </div>
    </UnauthLayout>
  );
};
